import Link from 'next/link';

import { CountBadge } from '../count-badge.component';
import styles from './notification-link.component.module.scss';

type Props = {
  unreadCount: number;
};

export const NotificationLink = ({ unreadCount }: Props) => {
  return (
    <div>
      <Link
        className={styles.mobileLoginNotificationLink}
        href="/notifications"
      >
        <svg
          aria-label="お知らせ"
          fill="#afb7bc"
          height="20"
          viewBox="0 0 20 20"
          width="20"
        >
          <path d="M10.0001 18C11.1032 18 12.0001 17.1031 12.0001 16H8.00008C8.00008 17.1062 8.89696 18 10.0001 18ZM16.7313 13.3219C16.1282 12.6719 14.997 11.6969 14.997 8.5C14.997 6.07188 13.2938 4.12812 11.0001 3.65V3C11.0001 2.44687 10.5532 2 10.0001 2C9.44696 2 9.00008 2.44687 9.00008 3V3.65C6.70633 4.12812 5.00321 6.07188 5.00321 8.5C5.00321 11.6969 3.87196 12.6719 3.26883 13.3219C3.08133 13.525 2.99696 13.7656 3.00008 14C3.00321 14.5125 3.40633 15 4.00321 15H15.997C16.5938 15 16.997 14.5125 17.0001 14C17.0032 13.7625 16.9188 13.5219 16.7313 13.3219Z" />
        </svg>
        {unreadCount > 0 && <CountBadge count={unreadCount} />}
      </Link>
    </div>
  );
};
